import axios from 'lib/utils/axios';

import getReport from 'api/requests/report/getReport';
import getReportTemplateListByType from 'api/requests/report/getReportTemplateListByType';
import deleteReportTemplate from 'api/requests/report/deleteReportTemplate';
import editReportTemplate from 'api/requests/report/editReportTemplate';

import logrocket from '@/services/logrocket';

// eslint-disable-next-line no-unused-vars
async function fetchReport({ commit }, params) {
  try {
    console.log('fetchReport', params);
    const { data } = await getReport(axios, params);

    return data;
  } catch (error) {
    logrocket.logger(error);
    throw new Error(error);
  }
}

async function fetchReportTemplateListByType({ commit }, type) {
  try {
    const { data } = await getReportTemplateListByType(axios, type);

    commit('SET_REPORT_TYPE', type);
    commit('SET_REPORT_TEMPLATE_LIST', data);
  } catch (error) {
    logrocket.logger(error);
    throw new Error(error);
  }
}

async function deleteReportTemplateById({ commit }, reportTemplateId) {
  try {
    await deleteReportTemplate(axios, reportTemplateId);

    commit('REMOVE_REPORT_TEMPLATE', reportTemplateId);
  } catch (error) {
    logrocket.logger(error);
    throw new Error(error);
  }
}

async function saveRenamedReportTemplate({ getters, dispatch }, templateName) {
  const { getCurrentEditingTemplate } = getters;

  try {
    await editReportTemplate(axios, {
      ...getCurrentEditingTemplate,
      name: templateName,
    });

    await dispatch('fetchReportTemplateListByType', getCurrentEditingTemplate.type);
  } catch (error) {
    logrocket.logger(error);
    throw new Error(error);
  }
}

export default {
  fetchReport,
  fetchReportTemplateListByType,
  deleteReportTemplateById,
  saveRenamedReportTemplate,
};
